import { render } from "./DateComponent.vue?vue&type=template&id=553d9b8c&scoped=true"
import script from "./DateComponent.vue?vue&type=script&lang=js"
export * from "./DateComponent.vue?vue&type=script&lang=js"

import "./DateComponent.vue?vue&type=style&index=0&id=553d9b8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553d9b8c"]])

export default __exports__